import { Tabs, TabsContent, TabsList, TabsTrigger } from 'components/navigation/Tabs';
import SimulationsTab from 'features/domain-simulation/SimulationsTab';
import useGetScenarios from 'hooks/useGetScenarios';

import 'features/domain-simulation/_styles.scss';

const DomainSimulationPage = () => {
    const { scenarios, isLoading: scenariosIsLoading, isError: scenariosIsError } = useGetScenarios();

    return (
        <main className='DomainSimulationPage' data-testid='domain-simulation-page'>
            <h4 className='DomainSimulationPage__header'>Domain Simulation</h4>
            <div className='DomainSimulationPage__content'>
                <Tabs defaultValue='simulations-tab' orientation='vertical'>
                    <TabsList aria-label='domain simulation tabs'>
                        <TabsTrigger value='simulations-tab'>
                            <span data-testid='domain-sim-tab-simulations'>Simulations</span>
                        </TabsTrigger>
                        <TabsTrigger value='scenarios-tab'>
                            <span data-testid='domain-sim-tab-scenarios'>Scenarios</span>
                        </TabsTrigger>
                    </TabsList>
                    <TabsContent value='simulations-tab'>
                        <SimulationsTab
                            scenarios={scenarios}
                            scenariosIsLoading={scenariosIsLoading}
                            scenariosIsError={scenariosIsError}
                        />
                    </TabsContent>
                    <TabsContent value='scenarios-tab'>
                        <div className='DomainSimulationPage__tabContent'>
                            <div className='DomainSimulationPage__tabHeader'>
                                <div>
                                    <h5 className='DomainSimulationPage__tabTitle'>Scenarios</h5>
                                    <p>Manage simulation scenarios</p>
                                </div>
                            </div>
                        </div>
                        <div />
                    </TabsContent>
                </Tabs>
            </div>
        </main>
    );
};

export default DomainSimulationPage;
